module.exports = __webpack_public_path__ + "static/media/split-white.ae96af65.png";